<template>
    <div class="pd20">
        <div class="back">
            <i class="el-icon-back" @click="toBack">&nbsp;返回</i>
        </div>
        <el-card shadow="hover" class="mgb20">
            <div class="cka-Overview">
                <p style="padding-bottom: 10px;font-size: 16px">实验概览</p>
                <div class="newPractice-card">
                    <div class="newPractice-card-other">
                        <p style="font-size:18px">姓名</p>
                        <p style="font-size:36px">{{overview.userName}}</p>
                    </div>
                    <div class="newPractice-card-other">
                        <p style="font-size:18px">实验次数</p>
                        <p style="font-size:36px">{{overview.experimentNumber}}</p>
                    </div>
                    <div class="newPractice-card-other">
                        <p style="font-size:18px">实验总时长</p>
                        <p style="font-size:36px">{{overview.totalTime ? overview.totalTime : 0}}分钟</p>
                    </div>
                    <div class="newPractice-card-other"> 
                        <p style="font-size:18px">实验平均分</p>
                        <p style="font-size:36px">{{overview.avgScore ? overview.avgScore.toFixed(2) : overview.avgScore}}</p>
                    </div>
                </div>
            </div>
        </el-card>
        <!-- 实验记录明细  -->
        <registration :studentId="studentId" :courseId="courseId"></registration>
    </div>
</template>

<script>
import Headportrait from '../common/Studentcommon/Headportrait.vue';
import registration from '../common/Studentcommon/registration.vue';
export default {
    data() {
        return {
            studentId: this.$store.state.studentId,
            courseId: this.$store.state.courseId,
            userId: this.$store.state.userId,
            overview: {}
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
         //上一步
        toBack(){
            location.reload()
            if(sessionStorage.getItem('isOld')){
                location.reload()
                this.$router.go(-1)
                sessionStorage.removeItem('isOld')
            }else{
                this.$router.push(`/dashboard#0`)
                location.reload()
            }
        },
         
        getData() {
            this.$get(`${this.api.fictitiousScore}/${this.userId}/${sessionStorage.getItem('pattern')}`, {})
            .then(res => {
                this.overview = res.data
            }).catch(err => {});
        }
    },
    components: {
        Headportrait,
        registration
    }
};
</script>

<style lang="scss">
.back{
    height: 40px;
    line-height: 40px;
    font-size: 20px;
    color: #5277F7;
    i:hover{
        cursor: pointer;
        opacity: 0.7;
    }
}
.horizontalVerticalCenter {
    display: flex;
    align-items: center;
    flex-direction: column;
    background: #f5f5f5;
}

.headerContent {
    display: flex;
    align-self: flex-start;
    margin-left: 20px;
    margin-top: 20px;
    .p {
        height: 60px;
        line-height: 60px;
        font-size: 25px;
        margin-left: 10px;
        color: #328aff;
    }
}
.cka-Overview {
    margin-top: 20px;
    padding: 20px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 21px 0px rgba(48, 115, 248, 0.1);
    border-radius: 10px;
    p {
        font-size: 20px;
    }
    .newPractice-card {
        display: flex;
        justify-content: space-between;
        .newPractice-card-other:nth-child(1) {
            background-image: url('../../assets/img/student1.png');
            box-shadow: 0px 25px 20px -22px #ec92e0;
        }
        .newPractice-card-other:nth-child(2) {
            background-image: url('../../assets/img/student2.png');
            box-shadow: 0px 25px 20px -22px #60b8f6;
        }
        .newPractice-card-other:nth-child(3) {
            background-image: url('../../assets/img/student3.png');
            box-shadow: 0px 25px 20px -22px #fe787a;
        }
        .newPractice-card-other:nth-child(4) {
            background-image: url('../../assets/img/student4.png');
            box-shadow: 0px 25px 20px -22px #fbbb6e;
        }

        .newPractice-card-other {
            width: 24%;
            padding: 20px 30px;
            box-sizing: border-box;
            box-shadow: 0px 3px 18px 0px rgba(84, 84, 84, 0.09);
            border-radius: 8px;
            background-size: 100% 100%;
            background-repeat: no-repeat;
            // box-sizing: border-box;
            p {
                font-size: 18px;
                color: #ffffff;
            }
            p:last-child {
                margin-top: 10px;
                color: #ffffff;
                font-size: 26px;
            }
        }
    }
}

.CKA-overview {
    height: 200px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 21px 0px rgba(48, 115, 248, 0.1);
    border-radius: 10px;
}

.CheckWorkAttendance-head {
    margin-top: 20px;
    width: 95%;
    display: flex;
    margin-bottom: 20px;
    p {
        margin-left: 20px;
        color: #328aff;
        font-size: 20px;
    }
}
</style>